import styled from "styled-components/macro";
import {
  Flex,
  ContentFormatter,
  Button,
} from "@ebscois/react-component-library";
import {
  heights,
  reservedSpace,
  pixelsPerRem,
} from "../../util/mediaConstants";

const tocPadding = 0.75;

export const AhfsContent = styled(ContentFormatter)`
  max-width: 50rem;

  h1 {
    margin-top: 0;
  }

  u {
    text-decoration: none;
  }

  hr {
    display: none;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${({ theme }) => theme.colors.gray800};
  }

  table {
    table-layout: auto;
    max-width: 100%;
  }

  thead tr td {
    border-top: 1px solid;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  padding-top: 0;

  @media print {
    @page {
      size: auto;
      margin-bottom: 2cm;
    }
  }
`;

export const FlexTocColumn = styled(Flex)`
  ${({ theme }) => `
    flex-direction: column;
    margin-right: 1.5rem;
    border-right: 1px solid ${theme.colors.gray400};
    width: 100%;
    @media (max-width: ${theme.breakpoints.md}) {
      display: none !important;
    }
    @media print {
      display: none !important;
    }
 `}
`;

export const FlexUpdates = styled(Flex)`
  ${({ theme }) => `
    flex-direction: column;
 `}
`;

export const FlexChecklistInfoColumn = styled(Flex)`
  ${({ theme }) => `
    flex-direction: column;
    padding-right: ${tocPadding}rem;
    padding-left:${tocPadding}rem;
    margin-right: 1.5rem;
    width: 100%;

    @media print {
      display: none !important;
    }
 `}
`;

export const FlexContainer = styled(Flex)`
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    flex-direction: column;
  }

  @media print {
    display: block;
  }
`;

export const TocWrapperDiv = styled.div`
  ${({ theme, windowSize, isHeaderFixed, elementScroll, rightRailWidth }) => {
    let tocPosition = "sticky";
    let tocWidth = "100%";
    let tocHeight = "auto";
    let topOffset = (heights.header.lg + heights.mfeHeader.lg) * pixelsPerRem;

    if (isHeaderFixed) {
      tocHeight = `${
        windowSize.height - reservedSpace.height.lg * pixelsPerRem
      }px`;
    }

    return `
      background-color: ${theme.colors.white};
      position: ${tocPosition};
      height: ${tocHeight};
      width: ${tocWidth};
      top: ${topOffset}px;
      overflow-y: auto;
      padding-right: ${tocPadding}rem;
    `;
  }}
`;

export const FlexRightRailColumn = styled(Flex)`
  overflow-x: hidden;
  flex-direction: column;
  margin-left: 1.5rem;
  width: 100%;
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: none !important;
  }

  @media print {
    display: none !important;
  }
`;

export const FlexContentColumn = styled(Flex)`
  @media print {
    display: block;
    width: 100% !important;
  }
`;

export const ContentPageRightRail = styled.div`
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: none;
  }
`;

export const StyledInfoText = styled(ContentFormatter)`
  border: 1px solid ${({ theme }) => theme.colors.gray500};
  padding-left: 0.75rem;
  margin-bottom: 0.5rem;
`;

export const ContentBlockWrapper = styled.div`
  flex-basis: 100%;
  word-break: break-word;
  hyphens: auto;
`;
export const TopicMenuButton = styled(Button)`
  padding: 0.25rem 0.5rem;

  @media print {
    display: none;
  }

  &&&& {
    color: ${({ theme }) => theme.colors.gray800};
    fill: ${({ theme }) => theme.colors.gray800};
  }
`;
export const TocMobileWrapper = styled.div`
  overflow: auto;
  padding: 0 0.75rem 1rem;
  cursor: pointer;
`;

export const TocMobileOverlay = styled.div`
  cursor: auto;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  z-index: ${({ theme }) => theme.zIndex.modal};
  width: 100%;
  height: 100vh;
  background-color: ${({ theme }) => theme.colors.white};
`;

export const TocMobileCloseButton = styled(Button.Action)`
  margin-left: auto;
`;

export const TocMobileButtonWrapper = styled.div`
  ${({ theme }) => theme.space.md};
`;

export const TocMobileNameHolder = styled.div`
  display: flex;
  align-items: center;
  hyphens: auto;
  word-break: break-word;
  padding: ${({ theme }) => `${theme.space.sm}`};

  @media print {
    display: none;
  }
`;
